import {useInvertedSurface} from '@hconnect/common/styles/invertedSurface'
import {Button, useFundamentalTheme} from '@hm/fundamental'
import {mdiChevronLeft} from '@mdi/js'
import React from 'react'

interface BackToLinkProps {
  target: string
  targetName: string
  // function from react-router-dom v5 or v6 push or navigate
  navigate: (route: string) => void
}

export const BackToLink: React.FC<BackToLinkProps> = ({target, targetName, navigate}) => {
  const inverted = useInvertedSurface()
  const {currentTheme} = useFundamentalTheme()
  const onBlueSurface = inverted || currentTheme === 'ThemeLightBlue'

  return (
    <Button
      type="button"
      variant="tertiary"
      icon={mdiChevronLeft}
      iconSize="large"
      colorClass={
        onBlueSurface
          ? 'bg-transparent text-foreground_inverted_hover hover:text-foreground_inverted focus-visible:text-foreground_inverted'
          : 'bg-transparent text-foreground_faded hover:text-foreground focus-visible:text-foreground'
      }
      className="mb-[4px] h-auto justify-start gap-x-0 rounded-none px-0 font-normal transition-colors"
      data-cy={`back-to-link-${targetName}`}
      data-test-id={`back-to-link-${targetName}`}
      onClick={() => navigate(target)}
    >
      {targetName}
    </Button>
  )
}
